import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from '@myplay/ui';

import { WHITE, BLACK, ORANGE, ORANGE_LIGHT } from '../../styles/colors';
import { capitalize } from '../../utils/stringManipulations';
import I18N from '../../I18N';

const ComputerUpload = ({ onBack, filePath, onChange, onUpload }) => {

  return (
    <div className="upload-video-modal__computer-modal" data-testid="computer-modal">
      <span>{capitalize(I18N.t("UPLOAD_VIDEO_FROM_COMPUTER"))}</span>
      <label className="upload-video-modal__computer-modal__input-label">
        <input
          id="file-input"
          type="file"
          accept="video/*"
          style={{ width: '0px' }}
          onChange={event => onChange(event)}
        />
        <div 
          className="upload-video-modal__computer-modal__input-label__input"
          style={{ color: filePath ? BLACK : "#b3b3b3" }}
        >
          {filePath ? filePath.split('\\')[filePath.split('\\').length - 1] : "Choose file"}
        </div>
        <div className="upload-video-modal__computer-modal__input-label__button">Browse</div>
      </label>
      <div className="upload-video-modal__computer-modal__buttons">
        <PrimaryButton
          color={WHITE}
          background={BLACK}
          onClick={onBack}
          showBorder
        >
          {capitalize(I18N.t("BACK"))}
        </PrimaryButton>
        <PrimaryButton
          color={WHITE}
          background={filePath ? ORANGE : ORANGE_LIGHT}
          onClick={onUpload}
          data-testid="upload-button"
        >
          {capitalize(I18N.t("UPLOAD"))}
        </PrimaryButton>
      </div>
    </div>
  );
};

ComputerUpload.propTypes = {
  filePath: PropTypes.string, 
  onBack: PropTypes.func, 
  onChange: PropTypes.func, 
  onUpload: PropTypes.func
};

ComputerUpload.defaultProps = {
  filePath: "", 
  onBack: ()=> {}, 
  onChange: ()=> {}, 
  onUpload: ()=> {}
}

export default ComputerUpload;